// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__37HL5","generalBottom":"styles_generalBottom__2B_zu","dropZoneGeneralImg":"styles_dropZoneGeneralImg__32I-W"};